import React, { useState, useEffect } from 'react';
import '../App.css';
import { useHistory, useLocation } from 'react-router-dom';
import { Button, Input } from 'reactstrap';
import MyLoader from './util/loader';
import Api from './api/api';
import { ToastContainer } from 'react-toastify';
import 'reactjs-popup/dist/index.css';

const MergeCats = () => {
    var history = useHistory()
    const location = useLocation()


    const [mergeThis, setMergeThis] = useState('');
    const [mergeTo, setMergeTo] = useState('');

    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        //
    }, [])

    const mergeNow = ()=>{
        if(mergeThis === '' || mergeTo === ''){
            return
        }
        setLoader(true)
        Api.mergeCategory(mergeThis, mergeTo,
            (response) => {
                setLoader(false)
                console.log(JSON.stringify(response)); 
                history.goBack()
            },
            (error) => {
                setLoader(false)
            });
    };

    return (
        <div className='main'>

            <div className='titlebar' style={{ backgroundColor: '#f2f2f2', padding: 10, margin: -15 }}>
                <div style={{ color: 'blue' }}>
                    Merge Categories
                </div>
            </div>
            <div style={{ marginTop: 20, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ display: 'flex', width: 600, marginTop: 20, alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>

                    <div style={{ display: 'flex' }}>
                        <Input
                            style={{ fontSize:18, width:300 }}
                            type='number'
                            placeholder='Enter Child CatID'
                            value={mergeThis}
                            onChange={(event) => setMergeThis(event.target.value)} />
                    </div>
                    <div style={{ display: 'flex', marginTop: 20 }}>
                        <Input
                            style={{ fontSize:18, width:300 }}
                            type='number'
                            placeholder='Enter Parent CatID'
                            value={mergeTo}
                            onChange={(event) => setMergeTo(event.target.value)} />
                    </div>

                    <Button
                        style={{ width: 300, marginBottom:15, backgroundColor: 'black', marginTop: 20, fontSize: 16 }}
                        className='btn-block btn-submit'
                        onClick={mergeNow}>
                        Merge
                    </Button>

                    <div>
                        <span style={{color:'red'}}>Notes:</span> 1st category will become child of the 2nd category. And this works for both library and special programs. If you want a category to become parent simply set his parent ID to 0.
                    </div>

                </div>
            </div>
            <MyLoader loader={loader} />
            <div>
                <ToastContainer />
            </div>
        </div>
    );
}

export default MergeCats;